export default "__VITE_ASSET__BO7t3mKi__"